export const getPercentDiff = (
  currentYearRevenue: number = 0,
  previousYearRevenue: number = 0,
  roundToInt: boolean = true
) => {
  if (currentYearRevenue === 0 && previousYearRevenue === 0) {
    return null
  }
  if (previousYearRevenue === 0) {
    return null
  }
  const division = currentYearRevenue / (previousYearRevenue || 1)
  const res = (division - 1) * 100

  const fixed = roundToInt ? Math.round(Number(res.toFixed(2))) : res.toFixed(2)

  return Number(fixed)
}
